module.exports = __webpack_public_path__ + "img/top.5bb88465.png";